'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _handleActions;

var _ActionTypes = require('../actions/ActionTypes');

var _ActionTypes2 = _interopRequireDefault(_ActionTypes);

var _fluxActions = require('flux-actions');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var initialState = null;

exports.default = (0, _fluxActions.handleActions)((_handleActions = {}, _defineProperty(_handleActions, _ActionTypes2.default.SET_CONSENT_RESPONSES, function (state, action) {
  return action.payload;
}), _defineProperty(_handleActions, (0, _fluxActions.combineActions)(_ActionTypes2.default.RESET_CONSENT_RESPONSES, _ActionTypes2.default.BOOKING_TIME_CONFLICT), function () {
  return initialState;
}), _handleActions), initialState);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/workspace/MeetingsUI/MeetingsLib/target/src/MeetingsLib/static-2.875/js/redux/reducers/legalConsentResponses.js
// module id = 536
// module chunks = 0